<template>
  <b-row>
    <b-col cols="12" lg="1">
      <h5 class="pt-1 text-center">#{{ index + 1 }}</h5>
    </b-col>
    <b-col cols="12" lg="11">
      <b-row>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <fg-input>
              <el-select
                      class="select-default"
                      v-b-tooltip.hover :title="$t('views.excmagreements.form.agreementCyclicTask.caseType')"
                      :placeholder="$t('views.excmagreements.form.agreementCyclicTask.caseType')"
                      filterable
                      v-model="agreementCyclicTask.caseType">
                <el-option v-for="option in caseTypesOptions"
                           class="select-default"
                           :value="option['@id']"
                           :label="option.title"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <fg-input>
              <el-select
                      class="select-default"
                      v-b-tooltip.hover :title="$t('views.excmagreements.form.agreementCyclicTask.caseGenre')"
                      :placeholder="$t('views.excmagreements.form.agreementCyclicTask.caseGenre')"
                      filterable
                      v-model="agreementCyclicTask.caseGenre">
                <el-option v-for="option in caseGenresOptions"
                           class="select-default"
                           :value="option['@id']"
                           :label="option.title"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <fg-input>
              <el-select
                      class="select-default"
                      v-b-tooltip.hover :title="$t('views.excmagreements.form.agreementCyclicTask.taskType')"
                      :placeholder="$t('views.excmagreements.form.agreementCyclicTask.taskType')"
                      filterable
                      v-model="agreementCyclicTask.taskType">
                <el-option v-for="option in taskTypeOptions"
                           class="select-default"
                           :value="option['@id']"
                           :label="option.title"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <input
                    id="agreementCyclicTask_daysInterval"
                    v-b-tooltip.hover :title="$t('views.excmagreements.form.agreementCyclicTask.daysQuanity')"
                    v-model="agreementCyclicTask.daysInterval"
                    class="form-control"
                    type="number"
                    min="0"
                    :disabled="autoSetFrequency !== 0"
                    placeholder="0">
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <fg-input>
              <el-select
                      class="select-default"
                      v-b-tooltip.hover :title="$t('views.excmagreements.form.agreementCyclicTask.frequency')"
                      :placeholder="$t('views.excmagreements.form.agreementCyclicTask.frequency')"
                      filterable
                      v-model="autoSetFrequency">
                <el-option v-for="option in frequencyOptions"
                           class="select-default"
                           :value="option.value"
                           :label="option.text"
                           :key="option.value">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
        <b-col cols="12" lg="2">
          <div class="form-group">
            <fg-input>
              <el-date-picker
                      :picker-options="{firstDayOfWeek: 1}"
                      v-b-tooltip.hover :title="$t('views.excmagreements.form.agreementCyclicTask.dateFrom')"
                      v-model="agreementCyclicTask.dateFrom"
                      type="date"
                      default-time="12:00:00">
              </el-date-picker>
            </fg-input>
          </div>
        </b-col>
        <b-col cols="12" lg="2">
          <div class="form-group">
            <fg-input>
              <el-date-picker
                      :picker-options="{firstDayOfWeek: 1}"
                      v-b-tooltip.hover :title="$t('views.excmagreements.form.agreementCyclicTask.dateTo')"
                      v-model="agreementCyclicTask.dateTo"
                      type="date"
                      default-time="12:00:00">
              </el-date-picker>
            </fg-input>
          </div>
        </b-col>
        <b-col cols="12" lg="2">
          <b-btn class="btn btn-danger mt-0 float-right" @click="removeAgreementCyclicTask(index)">
            <span v-if="!mobileView">{{ $t('buttons.delete') }}</span>
            <i v-else class="far fa-trash-alt"></i>
          </b-btn>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'AgreementCyclicTaskRow',
  props: {
    index: {
      type: Number,
      require: true
    },
    agreementCyclicTask: {
      type: Object,
      required: true
    },
    removeAgreementCyclicTask: {
      type: Function,
      required: true
    },
    taskTypeOptions: {
      type: Array,
      required: true
    },
    caseGenresOptions: {
      type: Array,
      required: true
    },
    caseTypesOptions: {
      type: Array,
      required: true
    }
  },
  watch: {
    autoSetFrequency: function (newVal, oldVal) {
      if (newVal !== 0) {
        this.agreementCyclicTask.daysInterval = newVal
      }
      // this.autoSetFrequency = 0
    }
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    }
  },

  data () {
    return {
      autoSetFrequency: 0,
      frequencyOptions: [
        {
          value: 0,
          text: this.$t('views.excmagreements.form.agreementCyclicTask.frequencyOptions.ownValue')
        },
        {
          value: 1,
          text: this.$t('views.excmagreements.form.agreementCyclicTask.frequencyOptions.byDay')
        },
        {
          value: 7,
          text: this.$t('views.excmagreements.form.agreementCyclicTask.frequencyOptions.byWeek')
        },
        {
          value: 30,
          text: this.$t('views.excmagreements.form.agreementCyclicTask.frequencyOptions.byMonth')
        },
        {
          value: 90,
          text: this.$t('views.excmagreements.form.agreementCyclicTask.frequencyOptions.byThreeMonths')
        },
        {
          value: 180,
          text: this.$t('views.excmagreements.form.agreementCyclicTask.frequencyOptions.bySixMonths')
        },
        {
          value: 365,
          text: this.$t('views.excmagreements.form.agreementCyclicTask.frequencyOptions.byYear')
        }
      ]
    }
  }
}
</script>
